<template>
    <div class="presentation">

Definition : <br>
The publication process has multiple tasks:
<ul>
  <li>Defines a target group and the student access right</li>
  <li>Associates a Test to the assessment</li>
  <li>Repack the test using the test runner pack</li>
  <li>Copy the new pack to a secured access URL</li> 
</ul> 

<p>The Publication Manager will allowed all operations for your digital assessment : click on Create a Publication to add a new assessement. Use the Publication list component to modify or remove existing publication.  Attention : if the assessment has started, it will be not possible to change its parameters.</p>

</div>

</template>